import styled from 'styled-components';

const CenteredBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const PhoneNumberContainer = styled.div`
  margin-bottom: 20px;
`;

const LeadsDataItem = styled.div`
  padding: 5px 14px;
`;

const Box = styled.div`
  border: 2px solid #ccc;
  padding: 40px;
`;

export default {
  CenteredBox,
  Box,
  PhoneNumberContainer,
  LeadsDataItem
};



// WEBPACK FOOTER //
// ./src/pages/SecureLeads/styles.js